module.exports = __webpack_public_path__ + "img/firefighting.2c6022a4.png";